import { render, staticRenderFns } from "./AppRankingEstrelas.vue?vue&type=template&id=4c310535&"
import script from "./AppRankingEstrelas.vue?vue&type=script&lang=js&"
export * from "./AppRankingEstrelas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports